module.exports = __webpack_public_path__ + "img/logo-horizontal-blanco.8870065d.png";